const ToPromise = $promise => {
  return new Promise(function (resolve, reject) {
    $promise.then(resolve, reject);
  });
};

export default ToPromise;
